"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Realea's values for the shared design-token contract.
 *
 * A "mostly white with one accent" system. Realea has no typeface of its
 * own, so `fontFamily` stays "inherit" (components inherit the browser
 * default). Applied once at the SPA root, so every component mounted in it —
 * Realea's own and any shared one — reads these values.
 *
 * Realea supplies every contract token, including those its own pages do not
 * read, as harmless neutrals for whatever shared component reads them.
 */
const theme = exports.theme = {
  $$css: true,
  "var(--x1ywh52i)": "x15qkzmy"
};